import * as React from 'react'

function SvgIconLink(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="link" aria-labelledby="t-link d-link">
        <title id="t-link">{'Link'}</title>
        <desc id="d-link">{'3 links of a chain'}</desc>
        <path d="M30.535 1.464A4.967 4.967 0 0027 0c-1.336 0-2.592.52-3.535 1.464l-5 5A4.969 4.969 0 0017 10c.001.996.291 1.946.829 2.757l-5.072 5.072A4.966 4.966 0 0010 17a4.97 4.97 0 00-3.536 1.465l-5 5C.52 24.409 0 25.664 0 27s.52 2.591 1.464 3.535S3.664 32 5 32s2.591-.521 3.536-1.465l5-5A4.966 4.966 0 0015 22c0-.996-.291-1.945-.829-2.757l5.072-5.072A4.971 4.971 0 0022 15c1.336 0 2.592-.52 3.535-1.464l5-5a5.008 5.008 0 000-7.072zM13 22a2.98 2.98 0 01-.878 2.121l-5 5c-1.134 1.133-3.109 1.133-4.243 0C2.312 28.555 2 27.802 2 27s.312-1.555.878-2.121l5-5A2.982 2.982 0 0110 19c.454 0 .888.109 1.286.301l-1.149 1.149a.999.999 0 101.414 1.414l1.149-1.149c.19.396.3.831.3 1.285zM29.121 7.122l-5 5c-.887.886-2.284 1.069-3.396.568l1.146-1.139a.995.995 0 000-1.414.999.999 0 00-1.414 0l-1.146 1.15A2.832 2.832 0 0119 10c0-.802.312-1.555.879-2.122l5-5A2.978 2.978 0 0127 2c.801 0 1.555.312 2.121.878a3.004 3.004 0 010 4.244z" />
      </g>
    </svg>
  )
}

export default SvgIconLink
